// 风格配置文件
export const btnColor = '#8b60f0' // 右边操作列按钮颜色

export const btnDisableColor = '#cccccc' // 右边操作列按钮禁用颜色

// export const btnDecryptColor = '#9D8AC9' // 表格监控字段、虚拟号字段解密

export const lineColor = '#d2d2d6' // 线框颜色

export const divideColor = '#db3232' // 分割线颜色

export const headerTextColor = '#1a1a1a' // 头部字体颜色

export const tableTextColor = '#333333' // 表格字体颜色

export const headerColor = '#ebecf0' // 头部背景色

export const activeRowColor = '#fefadc' // 活动行背景色

export const stripeColor = '#fafafa' // 斑马条纹

export const headerHeight = 32 // 表头高度

export const rowHeight = 28 // 行高

export const boxEmptyHeight = headerHeight + rowHeight // 无数据时高度

export const cellPaddingWidth = 6 // 间距

export const fontSize = 13 // 字体大小

export const maskSec = window.__ERPGLOABLECONFIG__.maskSec || '✽✽✽'



// WEBPACK FOOTER //
// ./src/public/components/kye-canvas-table/config.js